import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",

  state: {
    project: {},
    excercise: "",
    country: "",
    name: "",
    surname: "",
    pesel: "",
    birth_date: "",
    birth_place: "",
    school_name: "",
    school_class: "",
    education: "",
    voivodeship: "",
    county: "",
    municipality: "",
    city: "",
    street: "",
    building_number: "",
    apartment_number: "",
    postal_code: "",
    contact_phone: "",
    email_address: "",
    occupation: "",
    foreigner: "",
    homeless: "",
    disabled: ""
  },

  mutations: {
    setProject(state, payload) {
      state.project = payload.project
    },
    setExcercise(state, payload) {
      state.excercise = payload.excercise;
    },
    setCountry(state, payload) {
      state.country = payload.country;
    },
    setName(state, payload) {
      state.name = payload.name;
    },
    setSurname(state, payload) {
      state.surname = payload.surname;
    },
    setPesel(state, payload) {
      state.pesel = payload.pesel;
    },
    setBirthDate(state, payload) {
      state.birth_date = payload.birthDate;
    },
    setBirthPlace(state, payload) {
      state.birth_place = payload.birthPlace;
    },
    setSchoolName(state, payload) {
      state.school_name = payload.schoolName;
    },
    setSchoolClass(state, payload) {
      state.school_class = payload.schoolClass;
    },
    setEducation(state, payload) {
      state.education = payload.education;
    },
    setVoivodeship(state, payload) {
      state.voivodeship = payload.voivodeship;
    },
    setCounty(state, payload) {
      state.county = payload.county;
    },
    setMunicipality(state, payload) {
      state.municipality = payload.municipality;
    },
    setCity(state, payload) {
      state.city = payload.city;
    },
    setStreet(state, payload) {
      state.street = payload.street;
    },
    setBuildingNumber(state, payload) {
      state.building_number = payload.buildingNumber;
    },
    setApartmentNumber(state, payload) {
      state.apartment_number = payload.apartmentNumber;
    },
    setPostalCode(state, payload) {
      state.postal_code = payload.postalCode;
    },
    setContactPhone(state, payload) {
      state.contact_phone = payload.contactPhone;
    },
    setEmailAddress(state, payload) {
      state.email_address = payload.emailAddress;
    },
    setOccupation(state, payload) {
      state.occupation = payload.occupation;
    },
    setForeigner(state, payload) {
      state.foreigner = payload.foreigner;
    },
    setHomeless(state, payload) {
      state.homeless = payload.homeless;
    },
    setDisabled(state, payload) {
      state.disabled = payload.disabled;
    },
  },

  actions: {
  },

  modules: {
  }
})
